import BrainstormTemplate from "../../Templates/Brainstorm";

export default function BrainstormPage() {
    return (
        <BrainstormTemplate />
    )
}